import React from 'react'

const ShedIcon = (props) => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" width="24.665" height="21.4" viewBox="0 0 24.665 21.4"><path d="M21.5 20.4v-1.4h-3.724v-13h6.724v12.45a.55.55 0 0 1-.55.55h-.45v1.4zm-9 0v-1.4h-8.5v1.4h-2v-1.4h-1.056v-.007h-.394a.55.55 0 0 1-.55-.55v-12.101a.545.545 0 0 1 .211-.433l7.7-6.05a.551.551 0 0 1 .339-.118.557.557 0 0 1 .34.118l7.7 6.05a.548.548 0 0 1 .211.433v12.1a.551.551 0 0 1-.551.55h-.256v.008h-1.194v1.4zm-7.258-2.6h6.092l-3.042-3.4zm3.858-4.3l3.217 3.6v-7.184zm-4.834 3.591l3.221-3.591-3.221-3.6zm4.028-4.491l3.237-3.609h-6.465zm9.335-7.818l-8.053-5.782h7.1a.555.555 0 0 1 .34.117l7.511 5.509.043.039a.24.24 0 0 1 .025.027.077.077 0 0 1 .012.013.407.407 0 0 1 .03.039l.028.045z" transform="translate(0 1)" fill={props.fill} /></svg>
  )
}

export default ShedIcon
